export class MachineSearchRequest {

    _page; // number
    _term; // string
    _machineStateIds; // number[]

    constructor() {
        this._page = 1;
        this._term = '';
        this._machineStateIds = undefined;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setMachineState(machineState) {
        this._machineStateIds =
            machineState === 1 || machineState === 2
                ? [machineState]
                : undefined;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                company_id: undefined,
                machine_state_ids: this._machineStateIds,
                show_only_deleted: false,
                include_only_company_machines: undefined,
                include_only_contractor_machines: true,
                retrieve_machine_documentation_state: true,
                skip_contractors_inactive: true,
                skip_companies_inactive: undefined,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/list/machine-search/MachineSearchRequest.js